import type { AuthUser } from './ports/AuthApplicationPort.ts';

/** Inclusion Social often puts cédula/login id in `usuarios.nombre`. */
export function looksLikeDocumentoId(value: string): boolean {
  const t = value.trim();
  if (!t) return false;
  const digits = t.replace(/\D/g, '');
  const compact = t.replace(/[\s.\-]/g, '');
  return digits.length >= 5 && digits.length <= 15 && digits.length >= compact.length * 0.85;
}

function emailLocalLabel(email: string): string {
  const local = email.split('@')[0]?.trim() ?? '';
  if (!local || looksLikeDocumentoId(local)) return '';
  const pretty = local.replace(/[._]+/g, ' ').replace(/\s+/g, ' ').trim();
  return pretty && !looksLikeDocumentoId(pretty) ? pretty : '';
}

/** Person name for PDF "Responsable" — never a document/login id. */
export function authResponsableLabel(user: AuthUser | null | undefined): string {
  if (!user) return '';
  const nombre = user.nombre?.trim() ?? '';
  const display = user.displayName?.trim() ?? '';
  if (nombre && !looksLikeDocumentoId(nombre)) return nombre;
  if (display && !looksLikeDocumentoId(display)) return display;
  // Last resort before empty: email local-part (e.g. ana.perez@… → "ana perez").
  return emailLocalLabel(user.email ?? '');
}

/** `usuarios.public_id` when present; else session `id` (local numeric / remote). */
export function authUsuarioPublicId(user: AuthUser | null | undefined): string {
  if (!user) return '';
  const publicId = user.publicId?.trim() ?? '';
  if (publicId) return publicId;
  return user.id.trim();
}
